import { combineReducers } from "redux";

import publicSlice from "./public/public-Slice";
import authenticationSlice from "./user-authentication/authentication-Slice";
import profileSlice from "./profile/profile-Slice";
import financeSlice from "./finance/finance-Slice";
import orderSlice from "./order/order-Slice";
import myreviewSlice from "./myreview/myreview-Slice";
import userSlice from "./user/user-Slice";

export const reducerMap = {
  authentication: authenticationSlice,
  publicAPIs: publicSlice,
  userProfile: profileSlice,
  finance: financeSlice,
  order: orderSlice,
  myReview: myreviewSlice,
  user: userSlice,
};

export default combineReducers(reducerMap);
